import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@app/shared/shared.module';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { MODAL_CLOSE_DELAY } from '@app/shared/utils/constants';
import { timer } from 'rxjs';

@Component({
  selector: 'slotcom-onboarding-quest-reward-modal',
  templateUrl: './onboarding-quest-reward.component.html',
  styleUrls: ['./onboarding-quest-reward.component.scss'],
  standalone: true,
  imports: [DisplayComponent, SharedModule],
})
export class OnboardingQuestRewardModalComponent implements OnInit {
  onboardingQuestRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);

  ngOnInit(): void {
    this.scheduleModalClose();
  }

  private scheduleModalClose(): void {
    timer(MODAL_CLOSE_DELAY).subscribe(() => this.handleModalFlow());
  }

  private handleModalFlow(): void {
    this.closeRewardModal();

    if (this.isEventComplete()) {
      this.openCompletionModal();
    }
  }

  private isEventComplete(): boolean {
    return this.onboardingQuestRewardModalData.properties.lastReward;
  }

  private closeRewardModal(): void {
    this.eventManager.closeModal(
      new Modal(this.onboardingQuestRewardModalData.id, ModalType.Persisted, this.onboardingQuestRewardModalData)
    );
  }

  private openCompletionModal(): void {
    this.eventManager.openModal(
      new Modal(
        NonPersistedModalName.OnboardingQuestEndModalComponent,
        ModalType.View,
        this.onboardingQuestRewardModalData
      )
    );
  }
}
